<template>
  <div class="temprature grid">
    <font-awesome-icon icon="thermometer-half" class="icon" />
    <div class="temprature__current row current">
      <span >{{ roundedTemprature }}°</span>
    </div>
    <div class="row extra">
      <span class="temprature__effective">Føles som {{ roundedWindChill }}°</span> 
    </div>
  </div>
</template>

<script>


export default {
name: 'temprature',
components: {

},

props: {
  temprature: {
    type: Number,
    default: 0
  }, 
  windChill: {
    type: Number,
    default: 0
  }
},

computed: {
  roundedTemprature(){
    return Math.round(this.temprature)
  },
  
  roundedWindChill(){
    return Math.round(this.windChill)
  }
}
}
</script>

<style lang="sass">

.temprature
  text-align: center
  
  
  &__current 
    
    span
      font-size: $primary-size
    
    svg 
      margin-right: 8px
      font-size: $unit-size
      
  .temprature__effective
    font-size: $detail-size
</style>